import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { AzureMariaDBTableDataset } from 'app/model/dataset/azure-maria-db.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: adfModelTypeMap.azureMariaDB.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureMariaDBTableDataset) }
})
export class AzureMariaDBCopySource extends TabularCopySource {
}
